import { Component } from '@angular/core';
import { ColumnTimeFrameDto, TimeFrameTypeDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-timeframe',
  templateUrl: './ap-column-timeframe.component.html',
})
export class ApColumnTimeFrameComponent extends ApColumnBase<ColumnTimeFrameDto> {
  timeframe: TimeFrameTypeDto | null;
  displayString: string;
  isDisable: boolean;
  patientId: string;
  visitId: string;

  load(): void {
    this.timeframe = this.columnInfoDto.GetTimeFrameCallback
      ? this.columnInfoDto.GetTimeFrameCallback(this.dataItem)
      : null;
    this.isDisable = this.columnInfoDto.IsDisable(this.dataItem);
    if (this.timeframe) {
      this.displayString = this.timeframe.Answer;
    }
    this.patientId = this.columnInfoDto.PatientId;
    this.visitId = this.columnInfoDto.VisitiId;
  }

  onChange(event: TimeFrameTypeDto){

    if (event){
      this.columnInfoDto.Change({dataItem: this.dataItem, timeFrame: event});
    }
  }
}


